import { AppThunkApi, PdpState } from '../../store';
import { refreshAuthorization } from './refreshAuthorization';
import { tryAuthorizeProject } from './tryAuthorizeProject';

export const withAuthorization = async (
    request: (state: PdpState) => Promise<Response>,
    thunkApi: AppThunkApi
) => {

    await tryAuthorizeProject(thunkApi);
    const response = await request(thunkApi.getState());

    if (response.status === 401) {
        await thunkApi.dispatch(refreshAuthorization()).unwrap();
        return await request(thunkApi.getState());
    } else {
        return response;
    }
};